import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { lightInputTextFieldColor, primaryColorDark } from './PDFStyles';
import { printIfDefined } from './PDFUtils.jsx';
import WhatIsCarePlan from './WhatIsCarePlan';
import { SectionedText } from './Components/SectionedText';
import { CenterpieceGreenLogoPDFSvg } from '@centerpiece/components';
import { Project, Quote } from 'store/api/models';

const styles = StyleSheet.create({
  body: {
    paddingHorizontal: 10,
    marginVertical: 20,
  },
  title: {
    fontSize: 26,
    textAlign: 'center',
    fontFamily: 'Red Hat Display',
    fontWeight: 900,
    color: primaryColorDark,
  },
  logo: {
    height: '100px',
    width: '100px',
  },
  dot: {
    height: '10px',
    width: '10px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
  },
  view: {
    backgroundColor: '#e4f3fa',
  },
  image: {
    paddingTop: 23,
    paddingLeft: 10,
    minWidth: '200px',
  },
  textWrapper60: {
    flexBasis: '75px',
    flexGrow: 10,
    paddingTop: 15,
    paddingLeft: 15,
  },
  textWrapper40: {
    flexBasis: '75px',
    flexGrow: 10,
    paddingTop: 15,
    paddingRight: 10,
    paddingLeft: 10,
  },
  divider: {
    borderLeft: 1.5,
    borderLeftColor: '#76B041',
    borderLeftStyle: 'solid',
    marginTop: 5,
    height: '45px',
    flexGrow: 0.25,
    flexBasis: '10px',
  },
  infoText: {
    textAlign: 'left',
    fontSize: 13,
    flexBasis: 50,
    fontFamily: 'Red Hat Display',
    color: primaryColorDark,
    fontWeight: 400,
    paddingVertical: 7,
  },
  textBoxSubtitle: {
    textAlign: 'left',
    paddingBottom: 4,
    paddingTop: 8,
    fontFamily: 'Red Hat Display',
    fontSize: 14,
    color: primaryColorDark,
    fontWeight: 700,
  },
  textBox: {
    fontSize: 13,
    textAlign: 'left',
    fontFamily: 'Red Hat Display',
    color: primaryColorDark,
    fontWeight: 400,
    paddingHorizontal: 5,
  },
  column: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  preparedForRow: {
    flexBasis: '20px',
    flexGrow: 1,
    fontWeight: 'bold',
  },
  preparedForView: {
    backgroundColor: '#76B04112',
    height: '65px',
    border: `1px solid #76B041`,
    borderRadius: '4px',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
});
export const MainHeader = ({ debug }: { debug?: boolean }) => (
  <View style={styles.header} debug={debug}>
    <View style={styles.row} debug={debug}>
      <View style={styles.textWrapper60} debug={debug}>
        <CenterpieceGreenLogoPDFSvg />
      </View>
      <View style={styles.divider} debug={debug}></View>
      <View style={styles.textWrapper40} debug={debug}>
        <Text style={styles.title} debug={debug}>
          Purchase Order
        </Text>
      </View>
    </View>
  </View>
);

export const CoverPage = ({
  project,
  debug,
}: {
  project?: Project;
  debug?: boolean;
}) => (
  <View debug={debug}>
    <View style={styles.body} debug={debug}>
      <View style={[styles.preparedForView]} debug={debug}>
        <View style={[styles.row, { paddingLeft: 10 }]} debug={debug}>
          <View style={styles.preparedForRow} debug={debug}>
            <Text style={[styles.infoText]} debug={debug}>
              Project: {project?.title}
            </Text>
            {/* <Text style={styles.infoText} debug={debug}>
                Prepared Date: 
              </Text> */}
          </View>
        </View>
      </View>
    </View>
  </View>
);
